import { Box, Typography } from '@mui/material';
import nhsLogo from 'app/assets/nhs-logo.png';
import CheckmarkIcon from 'app/assets/icons/checkmark.svg?react';

export default function BadgeDisplay({ badges, isSupport, showBadges }) {
  if (!badges) return null;

  const hasBadges = showBadges && Object.values(badges).some(Boolean);

  if (!hasBadges) return null;

  return (
    <Box className="flex gap-6 items-center">
      {badges.commissionable && isSupport && (
        <Box className="px-8 py-1 text-white bg-green-550 rounded-full">Referred</Box>
      )}
      {badges.patientIsMyGPIntegrated && (
        <Box className="px-8 py-1 text-white bg-[#0670B2] rounded-full">MyGP</Box>
      )}
      {badges.patientIsCegedimIntegrated && (
        <Box className="px-8 py-1 text-white bg-[#3D92CF] rounded-full">PMR</Box>
      )}
      {badges.patientIsERDIntegrated && (
        <Box className="px-8 py-1 text-white bg-[#104526] rounded-full">eRD/MCR</Box>
      )}
      {badges.nhsIntegrated && <img src={nhsLogo} alt="NHS logo" />}
      {badges.managedPatient && (
        <Box className="px-8 py-4 flex gap-4 items-center border border-border rounded-full">
          <CheckmarkIcon className="text-typography-success" />
          <Typography className="font-500 text-12 text-typography-primary">
            managed patient
          </Typography>
        </Box>
      )}
    </Box>
  );
}
